import countries from '../data/countries.json';

// Country/currency/dial-code data is now a static snapshot (see
// scripts/generate-countries.js) instead of a live fetch — REST Countries'
// v5 API requires a key, restricts browser calls to allowlisted origins,
// and caps the free tier at 500 requests/month, none of which make sense to
// spend on a lookup table that barely changes. Re-run the generator script
// occasionally to refresh this file.
export function useCountries() {
  return { countries, loading: false, error: null };
}